import { CommonModule } from '@angular/common';

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'jrui-kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrls: ['./kpi-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatCardModule],
})
export class KPICardComponent {
  @ViewChild('expanded', { read: ViewContainerRef })
  expanded!: ViewContainerRef;

  @Input() title = '';
  @Input() subtitle = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() stats: any = null;
}
